import {fetchDelete, fetchDisable, fetchGet, fetchPost, fetchPut} from './remote';
import moment from 'moment';

const formatQueryParam = (q) => {
    if (moment.isMoment(q)) {
        return q.toISOString();
    }

    if (Array.isArray(q)) {
        return q.join(",");
    }

    return window.encodeURIComponent(q);
};

export const params = (queryParams) => {
    const params = Object.keys(queryParams)
        .filter(k => queryParams[k] !== undefined && queryParams[k] !== null && queryParams[k] !== '')
        .filter(k => !moment.isMoment(queryParams[k]) || (moment.isMoment(queryParams[k]) && queryParams[k].isValid()))
        .filter(k => !Array.isArray(queryParams[k]) || queryParams[k].length > 0)
        .map(k => k + '=' + formatQueryParam(queryParams[k]))
        .join('&');
    return params ? '?' + params : '';
};

export const view = (entityName, id) => {
    const url = [entityName, id].join('/');
    return fetchGet(url);
};

export const count = (entityName, queryParams) => (
    fetchGet(entityName + '/count' + params(queryParams))
);

export const list = (entityName, queryParams) => {
    return fetchGet(entityName + params(queryParams))
};

export const save = (entityName, data) => (
    fetchPost(entityName, data)
);

export const update = (entityName, id, data) => {
    const url = [entityName, id].join('/');
    return fetchPut(url, data);
};

export const ackSDSAdd = (entityName, id, data) => {
    const url = [entityName, id].join('/');
    return fetchPut(url);
};

export const remove = (entityName, id) => {
    const url = [entityName, id].join('/');
    return fetchDelete(url);
};

export const removeDisable = (entityName, id) => {
    const url = [entityName, id].join('/removeDisable/');
    return fetchDisable(url);
};

export const resend = (entityName, id) => {
    const url = [entityName, 'resend', id].join('/');
    return fetchGet(url);
};

export const getresendstatus = () => {
    const url = ['veriskautosend', 'is_running'].join('/');
    return fetchGet(url);
}

export const autoresend_query = () => {
    const url = ['veriskautosend', 'is_running'].join('/');
    return fetchGet(url);
}

export const autoresend_start = () => {
    const url = ['veriskautosend', 'start'].join('/');
    return fetchGet(url);
}

export const autoresend_stop = () => {
    const url = ['veriskautosend', 'stop'].join('/');
    return fetchGet(url);
}

export const autoresend_sendall = () => {
    const url = ['veriskautosend', 'upload-all-sds'].join('/');
    return fetchGet(url);
}



// WEBPACK FOOTER //
// ./src/main/cruds/restApi.js